module.exports = __webpack_public_path__ + "img/acaki10.e24240d3.jpg";